import React, { ChangeEvent } from 'react'
import { Icon } from '../Icon'
import { lastStr } from '../../pages/policy/utils'

interface UIDocumentPickerProps {
  id: string
  label: string
  initialValue: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  accept?: string
  labelClassName?: string
  handleRemoveFile?: () => void
  isRejected?: boolean
}

const UIDocumentPicker: React.FC<UIDocumentPickerProps> = ({
  label,
  initialValue,
  onChange,
  accept = '.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg',
  labelClassName,
  handleRemoveFile,
  isRejected = false,
  id,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <label className="text-xs font-medium text-text1">
        {label}
        {isRejected}
      </label>
      <div
        className={`sm:mx-auto py-3 px-4 flex gap-3 items-center sm:w-full sm:max-w-3xl bg-${isRejected == false ? 'gray1' : 'textError'}   rounded-xl`}
      >
        <Icon
          name="IconFile"
          width={16}
          height={16}
          strokeWidth={1}
          stroke={isRejected == false ? '#02698C' : 'white'}
        />
        <label
          htmlFor={id}
          className={`text-sm font-normal text-${isRejected == false ? 'text1' : 'white'} flex-1 cursor-pointer ${
            labelClassName || ''
          }`}
        >
          {initialValue ? lastStr(initialValue) : 'Upload File'}
        </label>
        {!initialValue && (
          <input
            id={id}
            type="file"
            onChange={onChange}
            style={{ display: 'none' }}
            accept={accept}
          />
        )}
        {initialValue && (
          <div onClick={handleRemoveFile} className="cursor-pointer">
            <Icon
              name="IconTrash"
              width={16}
              height={16}
              strokeWidth={1}
              stroke={isRejected == false ? '#02698C' : 'white'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default UIDocumentPicker
